/** Normalize team Content Hub URL for window.open (supports protocol-relative //host). */
export function normalizeContentHubUrl(raw: string): string {
  const trimmed = raw.trim();
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) return trimmed;
  if (trimmed.startsWith('//')) return trimmed;
  return `//${trimmed}`;
}

export function openContentHubInNewTab(url: string): Window | null {
  const normalized = normalizeContentHubUrl(url);
  const w = window.open(normalized, '_blank', 'noopener,noreferrer');
  w?.focus();
  return w;
}
